import {
  arrayOf as arrayType,
  string as stringType,
  shape as shapeType,
  params,
  extend
} from '@thd-nucleus/data-sources';
import { dataModel as ProductPodDataModel } from '@thd-olt-component-react/product-pod';
import { MediaGallery } from '@thd-olt-component-react/media-gallery';

const mediaGalleryCollection = {
  collection: MediaGallery.dataModel.collection
};

const Section = extend({
  title: stringType(),
  isCarousel: stringType(),
  products: arrayType(shapeType({ itemId: stringType() }))
});

const Images = {
  url: stringType(),
  type: stringType()
};

const LinkedCollections = {
  id: stringType(),
  name: stringType(),
};

const AvailableOptions = {
  title: stringType(),
  linkedCollections: arrayType(shapeType(LinkedCollections))
};

const CollectionsContent = {
  title: stringType(),
  brand: stringType(),
  collectionType: stringType(),
  description: stringType(),
  section: arrayType(shapeType(Section)),
  availableOptions: AvailableOptions,
  media: shapeType({
    images: arrayType(shapeType(Images))
  }),
};

const kitchenCollectionDataModel = {
  fetchCollectionsContent: params({ collectionName: stringType().isRequired() }).shape(CollectionsContent),
  searchModel: params({
    itemIds: arrayType(stringType()).isRequired()
  }).shape({
    products: arrayType(shapeType(ProductPodDataModel.product))
  }),
};

export const KitchenCollectionDataModel = extend(
  kitchenCollectionDataModel,
  mediaGalleryCollection,
  ProductPodDataModel
);